import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";

import { withStyles } from "@mui/styles";
import client from "common/admin/client";
import { TenantValues } from "common/constants";

const styles = ({ spacing }) => ({
  formControl: {
    marginBottom: spacing(2),
  },
});

class LocationDialog extends Component {
  state = {
    selection: {},
    data: {},
  };

  componentDidMount() {
    this.loadResourceData("cities");
  }

  loadResourceData = async (name, query = {}) => {
    const data = await client.get(name, { query });
    this.setState((prevState) => ({
      ...prevState,
      data: { ...prevState.data, [name]: data },
    }));
  };

  handleSelect = (name, value, opts = {}) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        selection: { ...prevState.selection, [name]: value },
      }),
      () => {
        if (opts.populateResource) {
          const params = {};
          if (opts.populateParam) {
            params[opts.populateParam] = value;
          }
          if (Array.isArray(opts.populateResource)) {
            opts.populateResource.forEach((resource) => {
              this.loadResourceData(resource, params);
            });
          } else {
            this.loadResourceData(opts.populateResource, params);
          }
        }
      },
    );
  };

  handleSave = () => {
    const unitId = this.state.selection.units;
    const floorId = this.state.selection.floors;
    const companyId = this.state.selection.companies;

    if (!unitId) {
      return;
    }

    const userId = this.props.user.id;
    this.saveLocation(userId, unitId, floorId, companyId, (error) => {
      this.props.onClose({ error, updated: true });
    });
  };

  saveLocation = async (userId, unit_id, floorId, companyId, cb) => {
    try {
      await client.put(`users/${userId}/location_v2`, {
        body: { unit_id: unit_id, floor_id: floorId, company_id: companyId },
      });
      cb();
    } catch (error) {
      cb(error);
    }
  };

  renderControl = ({ label, resource, ...rest }) => {
    const { selection, data } = this.state;
    const items = data[resource] || [];

    return (
      <FormControl fullWidth className={this.props.classes.formControl}>
        <FormHelperText>{label}</FormHelperText>
        <Select
          value={selection[resource] || null}
          onChange={(e) => {
            const { value } = e.target;
            this.handleSelect(resource, value, rest);
          }}
        >
          {items.map((item) => (
            <MenuItem value={item.id} key={item.id}>
              {rest.displayItem ? rest.displayItem(item) : item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  render() {
    const { open, onClose } = this.props;
    const { floors } = this.state.selection;
    const building =
      this.state?.selection?.buildings && this.state?.data?.buildings?.length
        ? this.state.data.buildings.find(
            (building) => building.id === this.state.selection.buildings,
          )
        : null;
    const selectedTenantValue =
      building?.tenant_id !== undefined && building?.tenant_id !== null
        ? String(building.tenant_id)
        : "";

    return (
      <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Change Location</DialogTitle>
        <DialogContent>
          {this.renderControl({
            label: "City",
            resource: "cities",
            populateResource: "communities",
            populateParam: "city_id",
            displayItem: (item) => `${item.name}, ${item.region}`,
          })}

          {this.renderControl({
            label: "Neighborhood",
            resource: "communities",
            populateResource: "buildings",
            populateParam: "community_id",
          })}

          {this.renderControl({
            label: "Building",
            resource: "buildings",
            populateResource: ["floors", "companies"],
            populateParam: "building_id",
          })}

          {building && (
            <FormControl fullWidth className={this.props.classes.formControl}>
              <FormHelperText>Source</FormHelperText>
              <Select
                value={selectedTenantValue}
                name="tenant_id"
                id="tenant_id"
                disabled
              >
                {TenantValues.map((tenant) => (
                  <MenuItem value={tenant.value} key={tenant.value}>
                    {tenant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {this.renderControl({
            label: "Company",
            resource: "companies",
            displayItem: (item) => item.name,
          })}

          {this.renderControl({
            label: "Floor",
            resource: "floors",
            populateResource: "units",
            populateParam: "floor_id",
            displayItem: (item) => item.level,
          })}

          {this.renderControl({
            label: "Suite",
            resource: "units",
            displayItem: (item) => item.name,
          })}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.handleSave}
            variant="contained"
            color="primary"
            disabled={!floors}
          >
            Save
          </Button>
          <Button onClick={this.props.onClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

LocationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default withStyles(styles)(LocationDialog);
